exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#registros{\r\n    padding-top: 10px;\r\n    text-align: right;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/TPL ILG/3PL_ILG/src/app/components/articulo-list/articulo-list.component.css
// module id = ../../../../../src/app/components/articulo-list/articulo-list.component.css
// module chunks = main